import ProductMasonry from './ProductMasonry';
import VariantHelper from '../helpers/VariantHelper';
import ImageZoom from './ImageZoom';
import ProductSlideshow from './ProductSlideshow';
import RTE from './RTE';
import Select from './Select';
import themeUtils from '../themeUtils';

export default class Product {
  constructor(el, options) {
    this.setupProductDetails = this.setupProductDetails.bind(this);
    this.positionProductInfo = this.positionProductInfo.bind(this);
    this.el = el;
    this.$el = $(el);

    // Set up conditional options
    this.product = options.product;
    this.productSettings = options.product_settings;
    this.labels = JSON.parse($('[data-product-success-labels]').html());
    this.imagesLayout = options.images_layout;
    this.enableZoom = options.enable_zoom;
    this.enableCartRedirection = options.enable_cart_redirection;
    this.enableFixedPositioning = options.enable_fixed_positioning;

    this.window = $(window);
    this.zoomView = null;
    this.variantHelpers = null;
    this.productSlideshow = null;
    this.productMasonryLayout = null;
    this.rteViews = [];
    this.selectViews = [];

    this.$productForm = $('[data-product-form]', this.$el);

    this.$productContainer = $('.product', this.$el);
    this.productMainImage = $('.product-main-image', this.$el);
    this.productImages = $('.product-images', this.$el);
    this.$productThumbnails = $('.product-thumbnails img', this.$el);
    this.productThumbnail = $('.product-thumbnail', this.$el);
    this.productDetailsWrapper = $('.product-details-wrapper', this.$el);
    this.productDetails = $('.product-details', this.$el);
    this.productMessages = $('.product-message', this.$el);

    this.images = JSON.parse($('[data-images]', this.$el).text());

    this.$addToCart = $('.add-to-cart', this.$el);

    if (this.imagesLayout === 'slideshow') {
      this.productSlideshow = new ProductSlideshow({ el: this.productImages });
    } else if (this.imagesLayout === 'list') {
      this.window.on(
        'load.product-images-list resize.product-images-list',
        themeUtils.debounce(this.setupProductDetails, 100),
      );
    } else if (this.imagesLayout === 'masonry') {
      this.productMasonryLayout = new ProductMasonry({ el: this.$productContainer });
    }

    if ((this.imagesLayout === 'slideshow') && this.enableZoom) {
      const imageId = this.productMainImage.find('img').data('image-id');
      this.zoomView = new ImageZoom({ el: $(this.images[imageId]) });
    }

    $('.rte', this.$el).each((index, rte) => {
      this.rteViews.push(new RTE({ el: rte }));
    });

    $('select', this.$el).each((index, select) => {
      if (!select.hasAttribute('data-select-ignore')) {
        this.selectViews.push(new Select({ el: select }));
      }
    });

    this.setupVariants();

    if (this.enableFixedPositioning) {
      this.positionProductInfo();
    }

    this.$productThumbnails.on('click', event => this.swapProductImage(event));
    this.$addToCart.on('click', event => this.addToCart(event));

    if (Theme.enable_currency_converter) {
      $('[data-currency-converter]').trigger('updateCurrency');
    }

    if (Shopify.PaymentButton != null) {
      Shopify.PaymentButton.init();
    }
  }

  unload() {
    clearTimeout(this.positionTimeout);

    if (this.zoomView != null) {
      this.zoomView = null;
    }
    if (this.variantHelpers != null) {
      this.variantHelpers.unload();
    }
    if (this.productSlideshow != null) {
      this.productSlideshow = null;
    }
    if (this.productMasonryLayout != null) {
      this.productMasonryLayout.remove();
    }

    if (this.rteViews.length > 0) {
      this.rteViews = [];
    }

    if (this.selectViews.length > 0) {
      this.selectViews = [];
    }

    return this.window.off('.product-images-list');
  }

  setupVariants() {
    // Form selectors
    this.$addToCartButton = this.$el.find('.add-to-cart');
    this.$priceArea = this.$el.find('.product-price');

    // Setup product information
    this.$variantDropdowns = this.$el.find('[data-option-select]');

    this.variantHelpers = new VariantHelper({
      $selector: this.$variantDropdowns,
      type: 'select',
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      productSettings: this.productSettings,
      productJSON: this.product,
    });

    return this.$variantDropdowns.trigger('change');
  }

  swapProductImage(e) {
    const imageId = $(e.target, this.$el).data('image-id');

    const $nextImage = $(this.images[imageId]);
    $nextImage.css('display', 'none');

    const $image = $('[data-product-main-image]', this.$el);

    $nextImage.one('load', () => {
      $image.remove();
      return $nextImage.css('display', '');
    });
    $image.after($nextImage);
    if (this.zoomView != null) {
      this.zoomView.prepareZoom($nextImage);
    }
  }

  setupProductDetails() {
    if (this.imagesLayout !== 'list') { return; }

    this.productDetails.width(this.productDetailsWrapper.width());
  }

  positionProductInfo() {
    const detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
    let viewportHeight = window.innerHeight;

    if (document.documentElement.clientHeight < window.innerHeight) {
      viewportHeight = document.documentElement.clientHeight;
    }

    if (
      (window.innerWidth > 770)
      && (viewportHeight > detailsHeight)
    ) {
      this.triggerFixedProductInfo();
    } else {
      this.productDetails
        .removeClass('product-details-fixed')
        .removeClass('product-details-absolute');
    }

    return requestAnimationFrame(this.positionProductInfo);
  }

  triggerFixedProductInfo() {
    if (this.imagesLayout !== 'list') { return; }

    const scrollTop = this.window.scrollTop();
    const imagesHeight = this.productImages.get(0).getBoundingClientRect().height;
    const imagesOffsetTop = this.productImages.offset().top;
    const imagesOffsetBottom = imagesOffsetTop + imagesHeight;
    const detailsWrapperOffset = this.productDetailsWrapper.offset().top;
    let detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
    let detailsOffsetTop = this.productDetails.offset().top;
    let detailsOffsetBottom = detailsOffsetTop + detailsHeight;

    if (this.productDetails.get(0).getBoundingClientRect().height < imagesHeight) {
      // If we're far enough down the page that the content is near the window top
      if ((detailsWrapperOffset - scrollTop) < 0) {
        // Check if our details / images are out of line but low enough to "fix"
        if ((detailsOffsetBottom < imagesOffsetBottom) || (scrollTop < detailsOffsetTop)) {
          this.productDetails
            .removeClass('product-details-absolute')
            .addClass('product-details-fixed');
        }

        detailsHeight = this.productDetails.get(0).getBoundingClientRect().height;
        detailsOffsetTop = this.productDetails.offset().top;
        detailsOffsetBottom = detailsOffsetTop + detailsHeight;

        // If we're far enough down then this positions items near the bottom
        if ((detailsOffsetBottom >= imagesOffsetBottom) || (scrollTop >= detailsOffsetTop)) {
          this.productDetails
            .removeClass('product-details-fixed')
            .addClass('product-details-absolute');
        }
      } else {
        this.productDetails
          .removeClass('product-details-fixed')
          .removeClass('product-details-absolute');
      }
    }
  }

  addToCart(e) {
    if (this.enableCartRedirection) {
      return;
    }

    e.preventDefault();

    this.productMessages.html('');

    $.post(
      '/cart/add.js',
      this.$productForm.serialize(),
      null,
      'json',
    ).done((item) => {
      const message = Theme.addToCartSuccess
        .replace('**product**', item.title)
        .replace('**cart_link**', `<a href="/cart">${this.labels.cartLink}</a>`)
        .replace('**continue_link**', `<a href="/collections/all">${this.labels.continueLink}</a>`)
        .replace('**checkout_link**', `<a href="/checkout">${this.labels.checkoutLink}</a>`);

      return setTimeout(() => {
        this.productMessages
          .html(message)
          .addClass('success-message')
          .removeClass('error-message');
        return this.updateCart(item);
      },
      500);
    }).fail(error => this.handleErrors(error));
  }

  updateCart(newItem) {
    $('.mini-cart').removeClass('empty');
    const miniCartItemWrapper = $('.mini-cart-item-wrapper');
    const labels = this.labels;
    Shopify.getCart((cart) => {
      miniCartItemWrapper.empty();
      $('[data-cart-count]')
        .html(`<span class="cart-count-text">
          ${labels.cartHeaderText}</span>
          (<span class="cart-count-number">${cart.item_count}</span>)`);

      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        const price = Shopify.formatMoney(item.price, Theme.moneyFormat);
        const image = (item.image != null) ? item.image : labels.cartPlaceholderImg;

        miniCartItemWrapper.append(`<article
            class="mini-cart-item"
            data-variant="${item.variant_id}"
            data-url="${item.url}"
            data-title="${item.title}">
            <figure class="mini-cart-item-image">
              <a href="${item.url}">
                <img alt="${item.title}" src="${image}">
              </a>
            </figure>
            <div class="mini-cart-item-details">
              <p class="mini-cart-item-quantity">
                ${labels.cartQuantityText}: <span>${item.quantity}</span>
              </p>
              <p class="mini-cart-item-title">
                <a href="${item.url}">${item.title}</a>
              </p>
              <p class="mini-cart-item-price">
                <span class="money">${price}</span>
              </p>
            </div>
          </article>`);
      }

      const currencySwitcher = $('[data-currency-converter]');
      const currencyValue = currencySwitcher.val();

      // This is required to get around currency converter issues
      // when updating quantity and cart prices
      return currencySwitcher
        .val(Theme.currency).trigger('reset-currency')
        .val(currencyValue).trigger('reset-currency');
    });
  }

  handleErrors(error) {
    return setTimeout(() => this.$el.find('.product-message')
      .html(error.responseJSON.description)
      .addClass('error-message')
      .removeClass('success-message'),
    1000);
  }
}
